import { Capacitor } from '@capacitor/core';
import { Haptics, ImpactStyle, NotificationType } from '@capacitor/haptics';

const native = () => Capacitor.isNativePlatform();

export const hapticMedium  = () => native() && Haptics.impact({ style: ImpactStyle.Medium });
export const hapticLight   = () => native() && Haptics.impact({ style: ImpactStyle.Light });
export const hapticHeavy   = () => native() && Haptics.impact({ style: ImpactStyle.Heavy });
export const hapticWarning = () => native() && Haptics.notification({ type: NotificationType.Warning });
